enum BrandedContentAdFilters {
  Approved = 'bca_approved',
  Requested = 'bca_requested',
}

export { BrandedContentAdFilters }
